import navbar from "./NavBar.module.css";
import { useEffect, useState } from "react";


function NavBar ({hasWebsite, websiteLink}) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 430);
    
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 430);
        };
    
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    
    if (isMobile) return null;
    
    return (
        <nav id={navbar.navbar}>
            {hasWebsite && <li className={navbar.site}><a href={websiteLink} target="_blank" rel="noreferrer">LIVE SITE!!</a></li> }
            <li><a href="#introduction">INTRODUCTION</a></li>
            <li><a href="#problems">DAMN PROBLEMS</a></li>
            <li><a href="#system">MY SYSTEM</a></li>
            <li><a href="#leaning">FINAL LEARNING</a></li>
        </nav>
    );
}

export default NavBar